import styled from "styled-components"
import theme from "../theme"
import { Flex, FlexProps } from "rebass"

const SelectWrapper = styled<FlexProps>(Flex as any)`
  height: 45px;
  width: 90%;
  display: flex;
  align-items: center;
  color: ${theme.colors.modalText};
  position: relative;
  border: none;
  outline: none;
  font-size: 14px;
  font-family: ${theme.fonts.tertiary};
  line-height: 1.3em;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  -webkit-font-smoothing: subpixel-antialiased;
  color: ${theme.colors.inputText};
  background: none;
  @media screen and (max-width: 481px) {
    margin-top: 10%;
  }
`

export default SelectWrapper
